export default __webpack_public_path__ + "static/media/bannersWEBINARS_manual_11junio.b06d0fd0.jpg";